import { c as _c } from "react/compiler-runtime";
import { Actions } from './actions';
import { Cache } from './cache';
import { Size } from './size';
import css from './status.module.scss';
import { Verified } from './verified';
interface Props {
  value: string;
  onRefresh(): void;
}
export function Status(t0) {
  const $ = _c(12);
  const {
    value,
    onRefresh
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <Verified value={value} />;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Cache />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== value) {
    t3 = <Size value={value} />;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onRefresh || $[6] !== value) {
    t4 = <Actions value={value} onRefresh={onRefresh} />;
    $[5] = onRefresh;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <article className={css.status}>{t1}{t2}{t3}{t4}</article>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}